module.exports = __webpack_public_path__ + "img/woonveiligheid-logo.499e7c65.svg";